import React from "react";
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Badge,
    makeStyles
} from "@material-ui/core";
import {
    Inbox as InboxIcon,
    Send as SendIcon,
    Drafts as DraftsIcon,
    Delete as DeleteIcon
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    folderList: {
        width: "100%",
        backgroundColor: theme.palette.background.paper,
    },
    activeFolder: {
        backgroundColor: theme.palette.action.selected,
    },
}));

const EmailFolderList = ({ selectedFolder, onFolderChange, unreadCounts, folders = [] }) => {
    const classes = useStyles();

    // Ícones padrão baseados no nome da pasta
    const getIcon = (folderName) => {
        const name = folderName.toLowerCase();
        if (name === "inbox" || name.includes("entrada")) return <InboxIcon />;
        if (name.includes("sent") || name.includes("enviado")) return <SendIcon />;
        if (name.includes("draft") || name.includes("rascunho")) return <DraftsIcon />;
        if (name.includes("trash") || name.includes("lixeira") || name.includes("deleted")) return <DeleteIcon />;
        return <InboxIcon />;
    };

    return (
        <List className={classes.folderList}>
            {folders.map((folder) => (
                <ListItem
                    button
                    key={folder.name}
                    selected={selectedFolder === folder.name}
                    onClick={() => onFolderChange(folder.name)}
                    className={selectedFolder === folder.name ? classes.activeFolder : ""}
                >
                    <ListItemIcon>
                        {unreadCounts && unreadCounts[folder.name] > 0 ? (
                            <Badge badgeContent={unreadCounts[folder.name]} color="primary">
                                {getIcon(folder.name)}
                            </Badge>
                        ) : (
                            getIcon(folder.name)
                        )}
                    </ListItemIcon>
                    <ListItemText primary={folder.displayName} />
                </ListItem>
            ))}
        </List>
    );
};

export default EmailFolderList;
